


















import { Component, Vue } from "vue-property-decorator";
import TaskTypeNameInput from "../components/task-type/TaskTypeNameInput.vue";

@Component({
  components: {
    TaskTypeNameInput
  }
})
export default class TaskTypeNewModal extends Vue {
  name = "";

  show() {
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  init() {
    this.name = "";
  }

  submit() {
    this.$store.dispatch("tasktype/save", {
      id: 0,
      name: this.name
    });
    this.$nextTick(this.hide);
  }
}
